module.exports = __webpack_public_path__ + "static/media/Colonial.0b91c9a7.svg";